<script>
   import Icon from 'fa-svelte';
   import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
   import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
   import { lge } from './store.js';
   import { createEventDispatcher } from 'svelte';
   lge.useLocalStorage();
   const dispatch = createEventDispatcher();
   const updiv = faArrowUp;  
   const dndiv = faArrowDown; 
   
   function incr(){
      switch($lge) {
         case 1:
            break;
         case 3:
            $lge +=2;
         case 5:            
            break;
         case 7:
            $lge +=2;
            break;
         case 9:
            $lge +=2;
         case 11:               
            break;
         }
   }

   function decr(){
      switch($lge) {
         case 1:
            break;
         case 3:
            break;
         case 5:
             $lge -=2;
            break;
         case 7:
            break;
         case 9:
            $lge -=2;
            break;
         case 11:               
            $lge -=2;
            break;
         }
   }
</script>

<style>
	button {
	border: none;
	border-radius: 10px;
	color: white;
	padding: 8px;
	text-align: center;
	text-decoration: none;
	display: inline-block;
	font-size: 16px;
	margin: 4px 4px;
	}
	
	.block {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
	}
	
	#footer {
     bottom:0;
     width:100%;
	}
	
	.bon {
      background-color : #0cd1e8;
    }

    .boff {
      background-color: #3880ff;
    }

</style>


<div class="block" id="footer">
    <button class="button {$lge>1 ? 'bon' : 'boff'}" on:click={() => {incr();dispatch('LgeUpd')}}><Icon icon={updiv} /><sub>Div+</sub></button>
    <button class="button {($lge>6) ? 'bon' : 'boff'}" on:click={() => { $lge = 7; dispatch('LgeUpd')}}>HDTL</button>
    <button class="button {$lge === 1 ? 'bon' : 'boff'}" on:click={() => { $lge = 1; dispatch('LgeUpd')}}>Leicster</button>
    <button class="button {($lge>2)&&($lge<7) ? 'bon' : 'boff'}" on:click={() => { $lge = 3; dispatch('LgeUpd')}}>SLTL</button>
    <button class="button {$lge > 1 ? 'bon' : 'boff'}" on:click={() => {decr();dispatch('LgeUpd')}}><Icon icon={dndiv} /><sub>Div-</sub></button>
</div>  